import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Theme, useMediaQuery } from "@mui/material";
import { LoadingButton } from "@components";

type Props = {
  isSaving: boolean;
  isNextDisabled: boolean;
  onPrevious: () => void;
  onSubmit: () => void;
};

export const ParsingResultsActions = ({
  isSaving,
  isNextDisabled,
  onPrevious,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box
      display="flex"
      flexDirection={isLessSm ? "column" : "row"}
      justifyContent="space-between"
      gap={isLessSm ? 3 : 6}
      mt={6}
    >
      <Button
        data-testid="parsing-results-previous"
        variant="tertiary"
        onClick={onPrevious}
        fullWidth={isLessSm}
      >
        {t("navigation.previous")}
      </Button>
      <LoadingButton
        data-testid="parsing-results-next"
        fullWidth={isLessSm}
        isFetching={isSaving}
        disabled={isNextDisabled}
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        {t("navigation.next")}
      </LoadingButton>
    </Box>
  );
};
